"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./searchBox.scss");
const react_svg_1 = require("react-svg");
const search_box_icon_svg_1 = __importDefault(require("../../../assets/images/icons/search-box-icon.svg"));
const master_1 = require("../../../constants/master");
const styled_components_1 = __importDefault(require("styled-components"));
const Search_1 = require("../../../services/backend/Search");
const searchBoxTranslations_json_1 = __importDefault(require("./searchBoxTranslations/searchBoxTranslations.json"));
const services_1 = require("../../../services");
const StyledSearchBox = styled_components_1.default.div `
  &.focused {
    border: 2px solid ${(props) => props.primaryColor} !important;
  }

  .gray-search-box-icon {
    width: 15px;
    height: 15px;
  }

  .gray-search-box-icon .injected-svg {
    fill: #a0aec7 !important;
  }
`;
function SearchBox(props) {
    props.addTranslation(searchBoxTranslations_json_1.default);
    const config = (0, master_1.getMasterConfig)();
    const [isFocused, setIsFocused] = (0, react_1.useState)(false);
    const [search, setSearch] = (0, react_1.useState)("");
    const optimizedMixpanel = props.mixpanel
        ? new services_1.OptimizedMixPanel(props.mixpanel)
        : null;
    const wrapperRef = react_1.default.useRef(null);
    const inputRef = react_1.default.useRef(null);
    react_1.default.useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current &&
                !wrapperRef.current.contains(event.target)) {
                setIsFocused(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef]);
    react_1.default.useEffect(() => {
        if (isFocused && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isFocused]);
    const handleSearch = () => {
        if (!search || search.length < 3) {
            return;
        }
        if (isNaN(+search)) {
            goUser(search);
        }
        else {
            searchCredential(search);
        }
    };
    const goUser = (email) => __awaiter(this, void 0, void 0, function* () {
        if (!email || email.length < 3) {
            return;
        }
        let res = yield (0, Search_1.getSingleUser)(email);
        let profilePath = `/${props.activeLanguage ? props.activeLanguage.code : "en"}/profile/`;
        if (res && res.data.success) {
            optimizedMixpanel === null || optimizedMixpanel === void 0 ? void 0 : optimizedMixpanel.track("Search User", {
                email: email,
                username: res.data.username,
                isLogged: props.isLogged,
            });
            //TODO: Change username to userId
            let username = res.data.username;
            props.historyPush({
                pathname: profilePath + encodeURIComponent(username),
            });
        }
        else {
            props.historyPush({
                pathname: profilePath + email,
            });
        }
        setSearch("");
    });
    const searchCredential = (credNo) => {
        if (!credNo) {
            return;
        }
        else {
            optimizedMixpanel === null || optimizedMixpanel === void 0 ? void 0 : optimizedMixpanel.track("Search Credential", {
                credential_no: credNo,
                isLogged: props.isLogged,
            });
            props.historyPush({
                pathname: `/${props.activeLanguage ? props.activeLanguage.code : "en"}/verify/${credNo}`,
            });
            setSearch("");
        }
    };
    return (react_1.default.createElement("div", { ref: wrapperRef, className: `search-box-wrapper ${props.isLandingPage ? "landing-page" : ""}`, onClick: () => {
            setIsFocused(true);
            if (inputRef.current)
                inputRef.current.focus();
        } },
        react_1.default.createElement(StyledSearchBox, { primaryColor: config.primaryColor, id: "search-box", className: `${isFocused ? "focused" : ""} ${props.isLandingPage ? "landing-page" : ""} ${props.isMobile ? "mobile-search-box" : ""}` },
            !isFocused && (react_1.default.createElement("div", { className: "unfocus-row" },
                react_1.default.createElement(react_svg_1.ReactSVG, { src: search_box_icon_svg_1.default, className: "gray-search-box-icon", wrapper: "svg" }),
                !props.isMobile && (react_1.default.createElement("span", { className: "search-text" }, props.translate("search").toString())))),
            isFocused && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("input", { type: "text", value: search, ref: inputRef, onKeyPress: (e) => {
                        if (e.key === "Enter") {
                            handleSearch();
                        }
                    }, onChange: (e) => setSearch(e.target.value), onFocus: (e) => {
                        setIsFocused(true);
                        e.stopPropagation(); // stop event propagation
                    }, className: "search-box-input", placeholder: props.translate("search").toString() + "..." }),
                react_1.default.createElement(react_svg_1.ReactSVG, { src: search_box_icon_svg_1.default, className: "search-box-icon", onClick: (e) => {
                        handleSearch();
                    }, wrapper: "svg" }))))));
}
exports.default = SearchBox;
